import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { CategoryEntity } from "../Categories";
import { Offer } from "../Companies";
import { ProductAttachment } from "./ProductAttachment";
import { ProductBarcode } from "./ProductBarcode";
import { ProductCompatibility } from "./ProductCompatibility";
/**
 * Product class
 */

export class Product extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => this.model.id;

    this.getOriginalId = () => this.model.originalId;

    this.getTitle = () => this.model.title;

    this.getAlias = () => this.model.alias;

    this.getDescription = () => this.model.description;

    this.getRating = () => this.model.rating || 5;

    this.getPreview = () => this.model.preview;

    this.isFavorite = () => Boolean(this.model.isFavorite);

    this.getOptions = () => this.model.options || null;

    this.getProperties = () => this.model.properties || null;

    this.getMinPrices = () => this.model.minPrices;

    this.isPromo = () => Boolean(this.model?.minPrices?.pormo);

    this.getSettings = () => this.model.settings || null;

    this.getPrice = () => {
      const minPrices = this.getMinPrices();
      return minPrices && minPrices[0] && minPrices[0].sellingPrice || 0;
    };

    this.hasSerialNumber = () => Boolean(this.model.hasSerialNumber);

    this.getSapCode = () => this.model.sapCode;

    this.getLinkPath = () => `${this.model.alias}-${this.model.id}`;

    this.getBarcodes = barcodes => this.getRelation('barCodes', ProductBarcode, barcodes, true);

    this.getOffers = offers => this.getRelation('offers', Offer, offers, true);

    this.getAttachments = attachments => this.getRelation('attachments', ProductAttachment, attachments, true);

    this.getCompatibility = compatibility => this.getRelation('compatibility', ProductCompatibility, compatibility);

    this.getCategoriesEntities = categories => this.getRelation('categories', CategoryEntity, categories);
  }

  /**
   * Create product
   *
   * @param {object} object
   *
   * @return {Product}
   */
  static create(object) {
    return super.create(object?.result?.model ?? object?.result ?? object);
  }
  /**
   * Create list products
   *
   * @param {object} objects
   *
   * @return {Array.<Product>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map products
   *
   * @param {Array.<object>} objects
   * @param {function(Product): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get product id
   *
   * @return {number}
   */


}